<template>
  <a
    :href="href"
    target="_parent"
  >
    <HfIcon
      icon="external-link-alt"
      size="is-small"
    />
  </a>
</template>

<script setup lang="ts">
  import {computed} from 'vue';
  import COMMON_UTIL from '@/utils/common.util';
  import HfIcon from '@/components/ui/HfIcon.vue';
  import {RendererProps} from '@/components/stats/renderer/renderer.model';

  const props = defineProps<{
    props: RendererProps;
  }>();

  const href = computed(() => COMMON_UTIL.links.gameLink(String(props.props.value)));
</script>
